import { render, staticRenderFns } from "./CurrencyDropdown.vue?vue&type=template&id=10e2909c&scoped=true&"
import script from "./CurrencyDropdown.vue?vue&type=script&lang=ts&"
export * from "./CurrencyDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencyDropdown.vue?vue&type=style&index=0&id=10e2909c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2909c",
  null
  
)

export default component.exports